import { webshopSettings } from '~/store/webshopSettings'
export default defineNuxtRouteMiddleware(to => {
    if (webshopSettings().currentLang && !webshopSettings().availableLanguages.some(availableLang => availableLang.code === webshopSettings().currentLang)) {
        throw createError({ statusCode: 404, statusMessage: `Page not found: ${to.fullPath}` })
    }
})
